import ApolloClient, { Operation } from 'apollo-boost';
import { config } from './config';
import { getUserToken } from './cookieHelper';

export const client = new ApolloClient({
  uri: config.api,
  request: async (operation: Operation) => {
    const token = getUserToken();
    operation.setContext({
      headers: {
        authorization: token ? `Bearer ${token}` : ''
      }
    });
  }
});
